// extracted by mini-css-extract-plugin
export default {"TabsContainer":"FullWidthTabs_TabsContainer__RO6-M","TabsScroller":"FullWidthTabs_TabsScroller__0jVj2","TabsIndicator":"FullWidthTabs_TabsIndicator__ZymX9"};